import View from '../../View';
import { breakpoint } from '../../utils/dom';

/**
 * MediaButtons
 */
class MediaButtons extends View {
  constructor (node) {
    super(node);

    this.pageHeader = document.querySelector('.js-header');
    this.printButton = this.node.querySelector('.print');
    this.toolsButton = this.node.querySelector('.js-tools-toggle');
    this.toolsList = this.node.querySelector('.js-tools-content');
    this.shareButton = this.node.querySelector('.js-share-toggle');
    this.shareList = this.node.querySelector('.js-share-content');

    //Make the print button work
    this.printButton.addEventListener('click', (e) => {
      this.printArticle();
    });

    //toggle toollist on small screens
    this.toolsButton.addEventListener('click', (e) => {
      this.toggleToolsList(e);
    });

    //toggle share list buttons open/close
    this.shareButton.addEventListener('click', (e) => {
        this.toggleShareList(e);
    });

    window.addEventListener('keydown', (e) => {
      if (e.ctrlKey && (e.key == 'p' || e.charCode == 16 || e.charCode == 112 || e.keyCode == 80)) {
        e.preventDefault();
        e.stopImmediatePropagation();
        e.cancelBubble = true;
        this.printArticle();
      }
    });

    this.makeToolsSticky();
  }

  /**
   * Make the tools sticky
   */
  makeToolsSticky = () => {
    const offset = this.pageHeader.clientHeight + 20;

    new Waypoint({
      element: this.node,
      offset: offset,
      handler: function () {
        this.node.classList.toggle('sticky');
      }.bind(this)
    });
  };


  printArticle = () => {
    window.print();
  };

  //Toggle tool buttons open & closed§
  toggleToolsList = (e) => {
    if (!e.currentTarget.classList.contains('active')) {
      this.openToolsList(e);
    } else {
      this.closeToolsList(e);
    }
  };

  /**
   * Toggle tools list open/closed after click
   * @param e
   */
  openToolsList = (e) => {
    //animate open tools list
    TweenMax.set(this.toolsList, {
      height: 'auto',
    });
    TweenMax.from(this.toolsList, 0.5, {
      height: 0,
      ease: Power3.easeInOut,
    });

    e.currentTarget.classList.add('active');
  };

  /**
   * Toggle tools list open/closed after click
   * @param e
   */
  closeToolsList = (e) => {
    //animate close tools list
    TweenMax.set(this.toolsList, {
      height: 'auto',
    });
    TweenMax.to(this.toolsList, 0.5, {
      height: 0,
      ease: Power3.easeInOut,
    });

    e.currentTarget.classList.remove('active');

  };

  //Toggle share buttons open & closed
  toggleShareList = () => {
    this.shareList.classList.toggle('open');
  };

}

export default MediaButtons;



// WEBPACK FOOTER //
// frontend/js/components/blocks/MediaButtons.js